import { render, staticRenderFns } from "./h-paging.vue?vue&type=template&id=39247a56&scoped=true&"
import script from "./h-paging.vue?vue&type=script&lang=js&"
export * from "./h-paging.vue?vue&type=script&lang=js&"
import style0 from "./h-paging.vue?vue&type=style&index=0&id=39247a56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39247a56",
  null
  
)

export default component.exports